<template>

    <Page>

        <ImageAndText 
            animation="zoom"
            src="/WorkOrders/parameters.jpg"
            border
            image-class="rounded-xl"
            floor-shadow>

            <h2 class="mb-4">Considerations</h2>
            <ul class="mt-3 list-disc pl-6 font-normal text-white/80">
                <li><strong>$1,000 cap per Work Order</strong>; any additional costs are paid by the customer</li>
                <li>Work Orders fulfilled at the originating dealership's service centre</li>
                <li>Requests must meet program specific guidelines</li>
                <li>Customers must follow maximum allowed Work Orders per component</li>
            </ul>

        </ImageAndText>

    </Page>

</template>